import { Box, Grid, IconButton, Button, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import React, { useState } from "react";

const CreateCollection = () => {
  const navigate = useNavigate();

  const [nameCollection, setnameCollection] = useState("");
  const idOrganisation = localStorage.getItem("idOrganisation");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!nameCollection.trim()) {
      return;
    }

    const collectionData = {
      path: `organisations/${idOrganisation}/collections`,
      data: {
        nameCollection,
      },
    };

    try {
      const response = await fetch(
        "https://backend-betkiff.vercel.app/collections/addCollection",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(collectionData),
        },
      );

      const result = await response.json();
      console.log("Réponse du serveur :", result);

      if (response.ok) {
        navigate("/collections");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi :", error);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}>
      <IconButton
        onClick={() => navigate("/collections")}
        sx={{ position: "absolute", top: 79, left: 11.5 }}>
        <ArrowBackIosIcon
          sx={{ color: "rgba(90, 20, 121, 0.9)", fontSize: 30 }}
        />
      </IconButton>

      <Grid container spacing={2} sx={{ width: "80%", maxWidth: 400 }}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nom de la collection"
            value={nameCollection}
            onChange={(e) => setnameCollection(e.target.value)}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            fullWidth
            onClick={handleSubmit}
            variant="contained"
            sx={{
              backgroundColor: "rgba(90, 20, 121, 254)",
              fontWeight: "bold",
              color: "white",
            }}>
            Créer la collection
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateCollection;
